import { useState } from "react";
import { Button } from "reactstrap";
import styles from "./InvoicesComponents.module.scss";
import DatePicker from "react-datepicker";
import axios from "axios";
import moment from "moment";

export default function TotalSettlement() {
  const [selectedMonth, setSelectedMonth] = useState(
    moment().add("-1", "months").toDate()
  );
  const [loading, setLoading] = useState(false);
  const [dailySettlements, setDailySettlements] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [showTable, setShowTable] = useState(false);

  async function handleGenerateTotalSettlement() {
    setLoading(true);
    try {
      const response = await axios.post(
        "/invoices/generateTotalSettlement?selectedMonth=" + selectedMonth
      );
      if (response.status === 200) {
        setDailySettlements(response.data.dailySettlements);
        setTotalAmount(response.data.totalAmount);
        setShowTable(true);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className={styles.PaymentNoticeContainer}>
      <div className={styles.GenerateContainer}>
        <div className={styles.SelectContainer}>
          <div className={styles.MonthSelectContainer}>
            <div>Month:</div>
            <DatePicker
              dateFormat="MM/yyyy"
              selected={selectedMonth}
              onChange={(date) => setSelectedMonth(date)}
              showMonthYearPicker
              maxDate={moment().add("-2", "weeks").toDate()}
            />
          </div>
        </div>
        <div className={styles.BottomContainer}>
          <Button 
            color="primary" 
            onClick={handleGenerateTotalSettlement}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                Generating...
              </>
            ) : (
              "Generate Total Settlement"
            )}
          </Button>
        </div>
    </div>

      {showTable && (
        <div style={{ marginTop: "20px" }}>
          <div style={{ overflowX: "auto" }}>
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Amount (SGD)</th>
                </tr>
              </thead>
              <tbody>
                {dailySettlements.map((item, index) => (
                  <tr key={index}>
                    <td>{moment(item.date).format("DD MMM YYYY")}</td>
                    <td style={{ textAlign: "right" }}>${Number(item.amount).toFixed(2)}</td>
                  </tr>
                ))}
              </tbody>
              <tfoot>
                <tr>
                  <td>Total Amount</td>
                  <td style={{ textAlign: "right" }}>${Number(totalAmount).toFixed(2)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}